// Copyright 2022-2023 the .NET Foundation
// Licensed under the MIT License
/** A type-guard function for {@link GetViewAsTourMessage} */
export function isGetViewAsTourMessage(o) {
    return o.type === "get_view_as_tour" &&
        typeof o.threadId === "string";
}
//# sourceMappingURL=tours.js.map